import { useShowToasterNotification } from './useShowToasterNotification';

export const useSunVegasPublicApi = () => {
    const showToasterNotification = useShowToasterNotification();

    return {
        showToasterNotification
    };
};
